import axiosTokenInstance from 'services/api/backoffice';
import { MAKE_PREPAID, MAKE_PREPAID_ERROR } from '_models/redux/types';

// Action function
export const ActionMakePrepaid = (params) => async (dispatch) => {
  const { ticketId, val } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/support/tickets/${ticketId}/actions/make-prepaid`,
      val,
    );

    const { data, status } = response || {};

    dispatch({
      type: MAKE_PREPAID,
      payload: data || {},
      status: status || {},
      method: 'post',
    });
  } catch (e) {
    dispatch({
      type: MAKE_PREPAID_ERROR,
      payload: e || {},
    });
  }
};
